import PropTypes from 'prop-types';
import React from 'react';

import connectEditElementToBriefStore from 'contest/components/connected/connect-edit-element-to-brief-store';
import { connectReadElement } from 'contest/components/brief/read-element';
import Tooltip from '@99designs/react-components/components/Tooltip';
import { Matrix, MatrixItem } from 'contest/components/matrix';
import Mediabox from 'contest/components/mediabox';

const Image = ({ label, tooltip, imageSrc, isSelectable, isSelected, isDisabled, onClick }) => {
    const image = (
        <div onClick={onClick}>
            <Mediabox
                variations={[
                    'wide-meta',
                    isSelected ? 'selected-simple' : undefined,
                    isSelectable ? 'linked' : undefined,
                    isSelectable ? 'checkable-meta' : undefined,
                ].filter(e => e)}
                meta={label}
                disabled={isDisabled}
            >
                <img src={imageSrc} style={{ width: '100%', height: '100%' }} />
            </Mediabox>
        </div>
    );

    if (tooltip) {
        return (
            <Tooltip tooltip={tooltip} position="up-center">
                {image}
            </Tooltip>
        );
    } else {
        return image;
    }
};
Image.propTypes = {
    label: PropTypes.node.isRequired,
    imageSrc: PropTypes.string.isRequired,
    tooltip: PropTypes.string,
    isSelectable: PropTypes.bool,
    isSelected: PropTypes.bool,
    isDisabled: PropTypes.bool,
    onClick: PropTypes.func,
};
Image.defaultProps = {
    isSelectable: false,
    isSelected: false,
    isDisabled: false,
    onClick: undefined,
};

const ReadChoiceImage = ({ selections }) => {
    return (
        <Matrix large={3} normal={3} medium={3} small={3}>
            {selections.map(({ key, label, description, imageSrc }) => (
                <MatrixItem key={key}>
                    <Image label={label} tooltip={description} imageSrc={imageSrc} />
                </MatrixItem>
            ))}
        </Matrix>
    );
};
ReadChoiceImage.propTypes = {
    selections: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            description: PropTypes.string.isRequired,
            imageSrc: PropTypes.string.isRequired,
        })
    ).isRequired,
};

export const ViewMultipleChoiceImageElement = connectReadElement(
    ReadChoiceImage,
    element => ({
        selections: element.value.map(key => ({
            key: key,
            label: element.trans.choices[key].label,
            description: element.trans.choices[key].description,
            imageSrc: element.assets[key],
        })),
    }),
    element => element.value.length > 0
);

export class EditMultipleChoiceImageElement extends React.Component {
    constructor(props) {
        super(props);

        this.MAX_SELECTIONS = 3;

        this.clickHandler = this.clickHandler.bind(this);

        // Convert array ['a','b'] into a Set like lookup table {'a':true, 'b':true}
        const isSelected = this.props.value.reduce((isSelected, key) => {
            isSelected[key] = true;
            return isSelected;
        }, {});

        this.state = {
            isSelected: isSelected,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.value !== nextProps.value;
    }

    clickHandler(key) {
        return () => {
            const isSelected = this.state.isSelected;

            if (isSelected[key]) {
                delete isSelected[key];
            } else if (this.getSelections().length < this.MAX_SELECTIONS) {
                isSelected[key] = true;
            } else {
                return;
            }

            this.setState(
                {
                    isSelected: isSelected,
                },
                () => {
                    this.props.onChange(this.getSelections(), true);
                }
            );
        };
    }

    getSelections() {
        return Object.keys(this.state.isSelected);
    }

    render() {
        const isMaxSelected = this.getSelections().length >= this.MAX_SELECTIONS;
        return (
            <Matrix large={5} normal={5} medium={4} small={3}>
                {Object.keys(this.props.choices).map(key => {
                    const selected = !!this.state.isSelected[key];
                    const disabled = !selected && isMaxSelected;
                    const tooltip =
                        this.props.choices[key].label && this.props.choices[key].description
                            ? this.props.choices[key].label +
                              ': ' +
                              this.props.choices[key].description
                            : '';

                    return (
                        <MatrixItem key={key}>
                            <Image
                                label={this.renderCheckbox(key, selected, disabled)}
                                tooltip={tooltip}
                                imageSrc={this.props.images[key]}
                                isSelectable={true}
                                isSelected={selected}
                                isDisabled={disabled}
                                onClick={this.clickHandler(key)}
                            />
                        </MatrixItem>
                    );
                })}
            </Matrix>
        );
    }

    renderCheckbox(key, selected, disabled) {
        return (
            <input
                name={key}
                type="checkbox"
                checked={!!selected}
                disabled={!!disabled}
                onChange={() => {}}
            />
        );
    }
}
EditMultipleChoiceImageElement.propTypes = {
    value: PropTypes.array.isRequired,
    choices: PropTypes.object.isRequired,
    images: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
};

export const ConnectedEditMultipleChoiceImageElement = connectEditElementToBriefStore(
    EditMultipleChoiceImageElement,
    element => ({
        value: element.value,
        choices: element.trans.choices,
        images: element.assets,
    })
);



// WEBPACK FOOTER //
// ./src/web/js/contest/components/brief/multiple-choice-image-element.jsx